export const authenticationConstants = {
  TOGGLED_SIGN_IN_MODAL: "TOGGLED_SIGN_IN_MODAL",
  TOGGLED_ERROR_MESSAGE_MODAL: "TOGGLED_ERROR_MESSAGE_MODAL",

  REFRESH_TOKEN: "REFRESH_TOKEN",

  SIGN_IN_START: "SIGN_IN_START",
  SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
  SIGN_IN_FAILURE: "SIGN_IN_FAILURE",

  VERIFY_2FA_OPEN: "VERIFY_2FA_OPEN",
  TOGGLED_2FA_MODAL: "TOGGLED_2FA_MODAL",
  VERIFY_2FA_START: "VERIFY_2FA_START",

  SET_2FA_LOADING: "SET_2FA_LOADING",

  CLEAR_SIGN_IN_ERROR_MESSAGE: "CLEAR_SIGN_IN_ERROR_MESSAGE",

  SIGN_IN_CREDENTIAL_START: "SIGN_IN_CREDENTIAL_START",
  SIGN_IN_DSA_START: "SIGN_IN_DSA_START",
  SIGN_IN_SSO_START: "SIGN_IN_SSO_START",

  SIGN_IN_SUCCESS_FOR_MOBILE: "SIGN_IN_SUCCESS_FOR_MOBILE",
  UPDATE_SIGN_IN_STATUS_FOR_MOBILE: "UPDATE_SIGN_IN_STATUS_FOR_MOBILE",

  GET_ACCOUNT_MKT: "GET_ACCOUNT_MKT",

  GET_ACCOUNT_LIST_START: "GET_ACCOUNT_LIST_START",
  GET_ACCOUNT_LIST_SUCCESS: "GET_ACCOUNT_LIST_SUCCESS",
  UPDATE_ACCOUNT_LIST_MOBILE_SUCCESS: "UPDATE_ACCOUNT_LIST_MOBILE_SUCCESS",
  GET_ACCOUNT_LIST_FAILURE: "GET_ACCOUNT_LIST_FAILURE",

  GET_ACCOUNT_INFO_START: "GET_ACCOUNT_INFO_START",
  GET_ACCOUNT_INFO_SUCCESS: "GET_ACCOUNT_INFO_SUCCESS",
  GET_ACCOUNT_INFO_FAILURE: "GET_ACCOUNT_INFO_FAILURE",

  GET_ACCOUNT_NAME_START: "GET_ACCOUNT_NAME_START",
  GET_ACCOUNT_NAME_SUCCESS: "GET_ACCOUNT_NAME_SUCCESS",
  GET_ACCOUNT_NAME_FAILURE: "GET_ACCOUNT_NAME_FAILURE",

  SIGN_OUT: "SIGN_OUT",
};
